var _excluded = ["children", "initialValues", "onSubmit", "validationSchema", "noValidate"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Formik, Form as FormikForm } from 'formik';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * A drop-in Formik Form wrapper that can be used with the FormElement component
 */
var Form = _ref => {
  var {
      children,
      initialValues,
      onSubmit = () => {},
      validationSchema,
      noValidate
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return ___EmotionJSX(Formik, _extends({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema
  }, props), formikProps => ___EmotionJSX(FormikForm, {
    noValidate: noValidate,
    "data-testid": "sp-ui-form"
  }, children instanceof Function ? children(formikProps) : children));
};
export default Form;